export default __webpack_public_path__ + "static/media/edm_fading_engagement.7aada7c1.svg";